import type { FunctionalComponent as FC } from 'vue'

type IProps = {
  data: any
}

export const VideoView = defineComponent({
  name: 'VideoView',
  props: {
    data: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const videoRef = ref()
    const onAfterChange = (current: number) => {
      // console.log(videoRef, current)
    }

    return () => (
      <a-carousel
        ref={videoRef}
        class="w-[528px] h-[298px] xmov-poper-carousel"
        afterChange={onAfterChange}
      >
        {props.data.map((url: string) => (
          <video
            src={url}
            class="block w-[528px] h-[298px] rounded-[6px] object-cover bg-back-1"
            loop
            autoplay
          />
        ))}
      </a-carousel>
    )
  },
})

export const Eye: FC<IProps> = (props) => {
  // 判断是否存在预览数据
  const hasEye =
    (!!props.data?.preview_video_list &&
      props.data?.preview_video_list.length > 0) ||
    (!!props.data.preview_videos && props.data.preview_videos.length > 0)

  const list = props.data?.preview_video_list || props.data?.preview_videos

  return (
    hasEye && (
      <a-popover
        placement="bottomRight"
        destroyPopupOnHide
        overlayClassName="xmov-popover-noarrow"
      >
        {{
          default: () => (
            <span class="absolute top-[10px] z-[1] right-[44px] w-[28px] h-[28px] bg-[rgba(0,0,0,0.4)] rounded-[50%] flex-center hover text-white text-[16px] hover:bg-[rgba(0,0,0,0.6)] eye-icon">
              {/* <iconpark-icon name="eye-fill" /> */}
              <svg
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-[16px] h-[16px]"
              >
                <path
                  data-follow-stroke="#fff"
                  d="M7.495 13.162a5.667 5.667 0 1 0 0-11.333 5.667 5.667 0 0 0 0 11.333Z"
                  stroke="#fff"
                  stroke-width="1.4"
                  stroke-linejoin="round"
                />
                <path
                  data-follow-stroke="#fff"
                  d="M7.495 5.495v4M5.5 7.5l3.995-.005m2.075 4.075 1.828 1.828"
                  stroke="#fff"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                class="w-[16px] h-[16px]"
              >
                <path
                  d="M14.928 7.961a.644.644 0 0 1 0 .467s-.058.175-.117.233c-.058.175-.175.35-.291.583-.292.467-.7 1.05-1.284 1.692-1.108 1.225-2.858 2.508-5.25 2.508-2.391 0-4.141-1.283-5.25-2.508a11.748 11.748 0 0 1-1.283-1.692l-.292-.583c-.058-.058-.116-.233-.116-.233-.059-.117-.059-.292 0-.467 0 0 .058-.175.116-.233.059-.175.175-.35.292-.584.292-.466.7-1.05 1.283-1.691 1.109-1.225 2.859-2.509 5.25-2.509 2.392 0 4.142 1.284 5.25 2.509.584.641.992 1.225 1.284 1.691l.291.584c.059.058.117.233.117.233ZM7.986 6.094c1.05 0 1.984.934 1.984 2.1 0 1.167-.934 2.1-1.984 2.1-1.05 0-1.983-.933-1.983-2.1 0-1.166.933-2.1 1.983-2.1Zm-3.15 2.1c0 1.75 1.4 3.267 3.15 3.267s3.15-1.517 3.15-3.267-1.4-3.266-3.15-3.266-3.15 1.516-3.15 3.266Z"
                  fill-rule="nonzero"
                  fill="#8580FF"
                  data-follow-fill="#8580FF"
                />
              </svg> */}
            </span>
          ),
          content: () => (
            <div class="p-[8px] w-[544px]">
              <VideoView data={list} />
              <div class="mt-[16px]">
                <span class="text-16 font-semibold">
                  {props.data?.title || props.data?.name}
                </span>
              </div>
              {(props.data?.tags?.length > 0 ||
                props.data?.personTags?.length > 0) && (
                <div class="mt-[12px] flex-y-center">
                  <div class="flex gap-[10px] flex-wrap flex-1 text-primary">
                    {props.data?.tags?.map((tag: string) => (
                      <span class="flex-center text-12 bg-back-3 dark:text-font-1 dark:bg-purple-1 hover:bg-back-5 dark:hover:text-font-1 dark:hover:bg-purple-1 rounded-[6px] px-[8px] h-[26px] font-semibold">
                        {tag}
                      </span>
                    ))}
                    {props.data?.personTags?.map((tag: { label: string }) => (
                      <span class="flex-center text-12 bg-back-3 dark:text-font-1 dark:bg-purple-1 hover:bg-back-5 dark:hover:text-font-1 dark:hover:bg-purple-1 rounded-[6px] px-[8px] h-[26px] font-semibold">
                        {tag.label}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {/* {(props.data?.description || props.data?.desc) && (
                <div class="text-font-60 mt-[10px]">
                  {props.data.description || props.data.desc}
                </div>
              )} */}
            </div>
          ),
        }}
      </a-popover>
    )
  )
}
